import React, { Component } from 'react';
import NumericInput from 'react-numeric-input';
import MyTooltip from './MyTooltip';

export default class ModifierComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.id,
      period: props.period,
      month: props.month ? props.month : 0,
      value: props.value ? props.value : null,
      type: props.type ? props.type : "",
      annotation: props.annotation ? props.annotation : "",
      interpolation: props.interpolation ? props.interpolation : "linear",
      isValid: false,
      isActive: props.isActive !== null ? props.isActive : true,
      style: {}
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      period: nextProps.period
    })
  }

  sendChangeEvent() {
    if(this.props.onChange)
      this.props.onChange(this);
  }

  numericChange(valueAsNumber, valueAsString, input) {
    this.setState({[input.name]: valueAsNumber}, () => {
      if(this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.validate();
      }, 500);
    });
  }

  monthChange(e) {
    this.setState({ month: parseFloat(e.target.value) }, () => {
      this.validate();
    });
  }

  typeChange(e) {
    this.setState({ type: e.target.value }, () => {
      this.validate();
    })
  }

  interpolationChange(e) {
    this.setState({ interpolation: e.target.value }, () => {
      this.validate();
    })
  }

  annotationChange(e) {
    this.setState({ annotation: e.target.value }, () => {
      if(this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.validate();
      }, 500);
    });
  }

  validate() {
    if(!isNaN(this.state.month) && this.state.month <= this.state.period &&
    this.state.month >= 1 && !isNaN(parseFloat(this.state.value)))
      this.setState({isValid: true}, () => { this.sendChangeEvent(); });
    else
      this.setState({isValid: false}, () => { this.sendChangeEvent(); });
  }

  toggleActive(e) {
    const isActive = !this.state.isActive;
    const style = isActive ? {} : { backgroundColor: '#AAA' };
    this.setState({
      isActive,
      style
    }, () => {
      this.validate();
    });
  }

  render() {
    var options = [];
    for(var i=0;i<this.state.period+1;i++) {
      options.push(<option key={i} value={i}>{i}</option>)
    }

    return(
      <div style={this.state.style} className="p-10 bg-panel mb-10 modifier">
        <div className="row">
          <form className="form-horizontal">
            <div className="activeButton">
              <input type="checkbox" name="active" onClick={(e) => this.toggleActive(e)} defaultChecked={this.state.isActive} />
            </div>
            <div className="glyphicon glyphicon-remove closeButton" onClick={(e, c) => { e.preventDefault(); this.props.onDelete(e, this); }}></div>
            <div className="col-lg-5">
              <label className="control-label lb-sm" htmlFor="month">Month</label>
              <MyTooltip text="The month this modifier will be in 100% effect." />
              <select className="form-control" name="month" value={this.state.month} onChange={(e) => this.monthChange(e)}>
                {options}
              </select>
            </div>

            <div className="col-lg-7">
              <label className="control-label lb-sm" htmlFor="arpu">Event Type</label>
              <MyTooltip text="Each type of data modifier changes your projections in different ways." />
              <select className="form-control" name="type" value={this.state.type} onChange={(e) => this.typeChange(e)}>
                <option value="">Please choose</option>
                <option value="arpu">ARPU ($)</option>
                <option value="churn">Revenue Churn (%)</option>
                <option value="traffic">Traffic (visits)</option>
                <option value="trial_conversion">Visitor to Trial (%)</option>
                <option value="subscriber_conversion">Trial to Subscriber (%)</option>
                <option value="expenses">Expense ($)</option>
								<option value="bank_change">Bank Change ($)</option>
              </select>
            </div>

            { this.state.type !== "" &&
              <div>
                <div className="col-lg-5">
                  <label className="control-label lb-sm" htmlFor="value">Value</label>
                  <MyTooltip text="Value of data modifier." />
                  <NumericInput className="form-control" name="value" onChange={(a,b,c) => this.numericChange(a,b,c)} value={this.state.value} />
                </div>
                <div className="col-lg-7">
                  <label className="control-label lb-sm" htmlFor="interpolation">Interpolation</label>
                  <MyTooltip text={<span>Interpolation tells the projection how to "fill in the blanks" between data points. <br/>If set to none, modifiers will begin affecting the projection immediately on their assigned month.</span>} />
                  <select className="form-control" name="interpolation" value={this.state.interpolation} onChange={(e) => this.interpolationChange(e)}>
                    <option value="linear">Linear</option>
                    <option value="none">None</option>
                  </select>
                </div>
                <div className="col-lg-12">
                  <label className="control-label lb-sm" htmlFor="annotation">Annotation</label>
                  <MyTooltip text="You can add a note to be displayed on the chart for this modifier." />
                  <input className="form-control" name="annotation" value={this.state.annotation} onChange={(e) => this.annotationChange(e)} />
                </div>
              </div>
            }
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ModifierComponent.js